import { Injectable } from '@angular/core';
import { CONFIG } from '../shared/config';
import { HttpGeneralService, InPatientParms, StockModuleSettingsParms } from '../shared';
import { PatientBloodTypeData } from '../blocks/patientbanner/patient-banner.service';
import { RegPatFollowups } from '../outpatient/out-pat-appointment/out-pat-reservation/out-pat-reservation.service';
import { EmrPatientParms } from '../medical-recored/medical-recored.interfaces';

let emrChartsUrl = CONFIG.baseUrls.emrCharts;
let reservationVisitUrl = CONFIG.baseUrls.reservationVisit;
let orderingUrl = CONFIG.baseUrls.ordering;

let OPPatListUrl = CONFIG.baseUrls.OPPatList;
let inpatientlistUrl = CONFIG.baseUrls.inpatientlist;
let erpatientlistUrl = CONFIG.baseUrls.emergencyReservation;

let medicalSheetsUrl = CONFIG.baseUrls.medicalSheets;
let stockTransUrl = CONFIG.baseUrls.StockTrans;



@Injectable({
    providedIn: 'root'
})
export class SpecializedEmrService {

    constructor(private httpGeneralService: HttpGeneralService) { }

    /*
     * GET Main Page Data
     * Service Function => Load Main Data for All Medical and Clinical Dept.
     */
    getEmrDoctorsData(PatientParms: EmrPatientParms) {
        return this.httpGeneralService.add(PatientParms, `${emrChartsUrl}/getDoctorsData`);
    }
    //new episode
    updateNewEpisode(service: any) {
        return this.httpGeneralService.post(service, `${emrChartsUrl}/EmrConvertToNewEpisode`)

    }

    /*
     * GET Out Patients
     * Service Function => Load Main Data for OutPatients.
     */
    getOutPatientData(outPatientParms: any) {
        return this.httpGeneralService.search(outPatientParms, OPPatListUrl);
    }
    updateStatus(selectedService: any) {
        return this.httpGeneralService.add(selectedService, `${reservationVisitUrl}/ChangeStatus`);
    }
    updateStepState(selectedService: any) {
        return this.httpGeneralService.add(selectedService, `${OPPatListUrl}/ChangeStepState`);
    }

    delayReservationToAnotherTime(service: RegPatFollowups) {
        return this.httpGeneralService.add(service, `${reservationVisitUrl}/delayReservation`)
    }



    /*
     * GET In Patients
     * Service Function => Load Main Data for InPatients.
     */
    getInPatientData(moduleParms: InPatientParms) {
        return this.httpGeneralService.search(moduleParms, inpatientlistUrl);
    }

    /*
     * GET Emergancy Patients
     * Service Function => Load Main Data for InPatients.
     */
    getEmergancyPatientData(moduleParms: InPatientParms) {
        return this.httpGeneralService.search(moduleParms, erpatientlistUrl);
    }
    getConsultionPatientData(moduleParms: InPatientParms) {
        return this.httpGeneralService.search(moduleParms, medicalSheetsUrl);
    }
    /*
     * GET Tabs Profile For Doctor SecLogin
     * Service Function => Load All Tabs from Doctor Profile.
     */
    ProfileTapsBySecLogin(emrParms: any) {
        return this.httpGeneralService.add(emrParms, `${emrChartsUrl}/ProfileTapsBySecLogin`);
    }

    /*
     * GET Order Patients
     * Service Function => Load All Other Patient Types like (Operations - Catheter - ...etc.).
     */
    orderSearch(orderSearch: any) {

        return this.httpGeneralService.search(orderSearch, `${orderingUrl}`);
    }
    emrPatListSearch(orderSearch: any) {
        return this.httpGeneralService.add(orderSearch, `${orderingUrl}/emrPatListSearch`);
    }

    /*
     * Blood Types Data
     */
    bannerDataLoad(SheetParms: any) {
        return this.httpGeneralService.add(SheetParms, `${medicalSheetsUrl}/bannerDataLoad`);
    }

    getPatBlodTypeRHData(code: number) {
        if (code > 0) {
        return this.httpGeneralService.get(code, `${medicalSheetsUrl}/getPatBlodTypeAndRH`);
        }
    }

    updatePatBloodType(_PatientBloodTypeData: PatientBloodTypeData) {
        return this.httpGeneralService.update<PatientBloodTypeData>(_PatientBloodTypeData.code, _PatientBloodTypeData, `${medicalSheetsUrl}/updatePatBlodTypeAndRH`);
    }

    getModuleSettings(parms: StockModuleSettingsParms) {
        return this.httpGeneralService.add(parms, `${stockTransUrl}/GetStockModuleSettings`);
    }
    SaveNotes(selectedService: EmrPatLastStatusUpdateNotes) {
        return this.httpGeneralService.update(selectedService.patCode, selectedService, `${medicalSheetsUrl}/SaveDrGeneralNotes`);
    }

    getAdminNotes(code: number) {
        return this.httpGeneralService.get(code, `${medicalSheetsUrl}/getNotes`);
    }


    getEmrPatientTimeline(SheetParms: any) {
        return this.httpGeneralService.add(SheetParms, `${medicalSheetsUrl}/EmrPatientTimeLine`);
    }
    updateAnesthesiaDecision(objData: any) {
        return this.httpGeneralService.post(objData, `${medicalSheetsUrl}/updateAnesthesiaDecision`);
    }
}
export interface ShowSessionObj {
    inpatient?: number;
    emergency?: number;
    outPatient?: number;
    // show?:number;
    clincs: number;
    sessions: number;
    getDocFavoriteList: number;
    fixedProfileTag: string;
}

export interface EmrPatLastStatusUpdateNotes {
    patCode: number;
    drGeneralNotes: string;

}
